import axios from "axios";

export const base_url = "https://apimiraclebaba.in/";

// get token from localStorage
const getTokenFromLocalStorage = localStorage.getItem("customer")
  ? JSON.parse(localStorage.getItem("customer"))
  : null;

export const config = {
  headers: {
    Authorization: `Bearer ${getTokenFromLocalStorage?.token || ""}`,
    accept: "application/json",
  },
};

// create axios instance
const axiosInstance = axios.create({
  baseURL: base_url,
  headers: config.headers,
});

export default axiosInstance;
